<template lang="pug">
  .b2b-table-servicios-empresas
    //- Filtros Tabla Empresas de un servicio
    b2b-filters-parties-service(:filter-options='options')

    ods-table(
      :data='partiesService.tableData',
      :default-sort="{prop: 'tradeName', order: 'ascending'}",
      style='width: 100%',
      @sort-change='orderOnServer',
      @cell-mouse-enter='handleCellMouseEnter',
      @selection-change='handleSelectionChange',
      highlight-current-row='',
      size='small',
      fit)
      ods-table-column(
        type='selection',
        width='55')
      ods-table-column(
        prop='partyName',
        :label='$t("parties.entity_table.name")',
        :show-overflow-tooltip='true',
        v-if='isShowNameServiceParty',
        sortable='')
      ods-table-column(
        prop='partyTaxIdNumber',
        :label='$t("parties.entity_table.identification_tax_number")',
        :show-overflow-tooltip='true',
        v-if='isShowTaxServiceParty',
        sortable='')
      ods-table-column(
        prop='country',
        :label='$t("parties.entity_table.country")',
        :show-overflow-tooltip='true',
        v-if='isShowCountryServiceParty',
        :formatter='formatterCountry',
        sortable='')
      ods-table-column(
        prop='province',
        :label='$t("parties.entity_table.province")',
        :show-overflow-tooltip='true',
        v-if='isShowProvinceServiceParty',
        sortable='')
      ods-table-column(
        prop='creationDateTime',
        :label='$t("parties.entity_table.creation_date_party")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowCreationDateTimeServiceParty && !this.withProject',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='creationDateTime',
        :label='$t("parties.entity_table.creation_date")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowCreationDateTimeServiceParty && this.withProject',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='registerOrCompaniesLocation',
        :label='$t("parties.entity_table.register_location_company")',
        :show-overflow-tooltip='true',
        v-if='isShowRegisterServiceParty',
        sortable='')
      ods-table-column(
        prop='seller',
        :label='$t("parties.entity_table.seller")',
        v-if='isShowSellerServiceParty && this.withProject',
        sortable='custom')
        template(slot-scope='scope')
          ods-switch(v-model='scope.row.seller',
            :disabled='!(canAdminIndra || canModifyProject || canModifyRole)',
            :active-color='primaryColor',
            inactive-color='#D5DCE0',
            @change='updateSeller(scope.row)')
      ods-table-column(
        prop='buyer',
        :label='$t("parties.entity_table.buyer")',
        v-if='isShowBuyerServiceParty && this.withProject',
        sortable='custom')
        template(slot-scope='scope')
          ods-switch(v-model='scope.row.buyer',
            :disabled='!(canAdminIndra || canModifyProject || canModifyRole)',
            :active-color='primaryColor',
            inactive-color='#D5DCE0',
            @change='updateBuyer(scope.row)')
      ods-table-column(
        prop='third',
        :label='$t("parties.entity_table.third")',
        v-if='isShowThirdServiceParty && this.withProject',
        sortable='custom')
        template(slot-scope='scope')
          ods-switch(v-model='scope.row.third',
            :disabled='!(canAdminIndra || canModifyProject || canModifyRole)',
            :active-color='primaryColor',
            inactive-color='#D5DCE0',
            @change='updateThird(scope.row)')
      ods-table-column(
        prop='sponsor',
        :label='$t("parties.entity_table.sponsor")',
        v-if='isShowSponsorServiceParty && this.withProject',
        sortable='custom')
        template(slot-scope='scope')
          ods-switch(v-model='scope.row.sponsor',
            :disabled='!(canAdminIndra)',
            :active-color='primaryColor',
            inactive-color='#D5DCE0',
            @change='updateSponsor(scope.row)')
      ods-table-column(
        prop='enable',
        :label='$t("parties.entity_table.enable")',
        v-if='isShowEnabledServiceParty',
        sortable='custom')
        template(slot-scope='scope')
          ods-switch(
            v-model='scope.row.enable',
            :disabled='!(canAdminIndra || canModifyProject || canModifyRole)',
            :active-color='primaryColor',
            inactive-color='#D5DCE0',
            @change='updateStatusParty(scope.row)')

      //- Ocultas por defecto
      ods-table-column(
        label,
        :render-header='renderHeaderActions',
        width='80')
        template(slot-scope='scope')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.detail') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral',
              @click='handleGoDetail(scope.row)')
              ods-icon(name='search', size='16')

    //- Paginación Tabla
    ods-row.b2b-table-servicios-empresas__pagination()
      ods-col.b2b-table-servicios-empresas__pagination--left(:span='0')
      ods-tooltip(:content='$t("invoices.buttons.download_csv_tooltip")', placement='bottom')
        ods-button(
            type='primary',
            size='mini',
            round='',
            icon='ods-icon-download'
            style='display:inline;'
            @click='downloadPartiesServiceCsv')
            | CSV
      ods-col.b2b-table-servicios-empresas__pagination--right(:span='24')
        ods-pagination(
          ref='pagination',
          popper-class='b2b-pagination__dropdown',
          @size-change='handleSizeChange',
          @current-change='handleCurrentChangePagination',
          :current-page.sync='currentPage',
          :page-sizes='[20, 50, 100]',
          :page-size='20',
          layout='total, sizes, prev, pager, next, slot',
          :total='partiesService.totalPartiesService')

    //- Empresas Seleccionadas
    transition(
      name='slide',
      mode='out-in')
      b2b-table-select-rows(
        v-if='multipleSelection.length',
        :total-select='multipleSelection.length')
        div(slot='actions')
          ods-tooltip(:content='$t("party_detail.buttons.add_delivery_method_tooltip")', placement='bottom')
            ods-button(
              v-if='this.multipleSelectionBuyerIds.length > 0'
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='openDialogDeliveryMehods')
              | {{ $t('party_detail.buttons.add_delivery_method') }}

    //- Dialogo métodos de entrega
    ods-dialog(
      ref='dialogCommunicationsMethods',
      :title='$t("party_detail.dialog_add_delivery_methods.title")',
      :visible.sync='isShowDialogDeliveryMehods',
      @close='handleCloseDialogCommunicationsMethods',
      width='30%')
      ods-form(
        ref='formDialogCommunicationsMethods',
        :model='dialogCommunicationsMethodsForm',
        :rules='rulesDialogCommunicationsMethodsForm')
          ods-form-item(
            v-if='showCommunicationFilter',
            :label='$t("party_detail.delivery_methods_table.sender")',
            prop='communicationsmethodsSenderId')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              @change='onChangeCommunicationsSender',
              v-model='dialogCommunicationsMethodsForm.communicationsmethodsSenderId',
              filterable)
              ods-option(
                v-for='option in optionsCommunicationsMethodsSender',
                :key='option.id',
                :label='option.name',
                :value='option.id')
          ods-form-item(
            :label='$t("party_detail.dialog_add_delivery_methods.method.label")',
            prop='communicationsmethodsId')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              @change='onChangeCommunicationsMethods',
              v-model='dialogCommunicationsMethodsForm.communicationsmethodsId',
              :placeholder='$t("party_detail.dialog_add_delivery_methods.method.placeholder")',
              filterable)
              ods-option(
                v-for='option in optionsFilterCommunicationsMethods',
                :key='option.id',
                :label="$t('communication_method.' + option.name)",
                :value='option.id')
          ods-form-item(
            v-if='hasCredentials',
            :label='$t("party_detail.delivery_methods_table.user")',
            prop='user')
            ods-input(
              v-model='dialogCommunicationsMethodsForm.user')
          ods-form-item(
            v-if='hasCredentials',
            :label='$t("party_detail.delivery_methods_table.password")',
            prop='password')
            ods-input(
              v-model='dialogCommunicationsMethodsForm.password')
          ods-form-item(v-if='isSuperAdmin')
            ods-checkbox(v-model='dialogCommunicationsMethodsForm.checkAddAll')
              span {{ $t('msg_generics.add_all_projects') }}
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='addCommunicationsMethodsParty("formDialogCommunicationsMethods")')
          | {{ $t('buttons.btnAdd') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bFiltersPartiesService from '@/views/administracion/empresas/B2bFiltersPartiesService'
import B2bTableMenuServiciosEmpresas from '@/views/administracion/empresas/B2bTableMenuServiciosEmpresas'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import filters from './filtros-servicios-empresas'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-table-servicios-empresas',
  mixins: [Utils],
  data () {
    return {
      currentRow: {},
      multipleSelection: [],
      multipleSelectionIds: [],
      multipleSelectionBuyerSponsorIds: [],
      multipleSelectionBuyerIds: [],
      withProject: true,

      // Paginación
      totalResults: 0,
      currentPage: 0,
      canModifyMasterData: true,
      canModifyRole: true,
      canModifyParty: true,
      isShowDialogDeliveryMehods: false,
      dialogCommunicationsMethodsForm: {
        communicationsmethodsId: null,
        password: null,
        user: null,
        communicationsmethodsSenderId: 'emission'
      },
      rulesDialogCommunicationsMethodsForm: {
        communicationsmethodsId: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'blur'
          }
        ],
        user: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'blur' }
        ]
      },
      showCommunicationFilter: false,
      hasCredentials: false,
      optionsCommunicationsMethodsSender: [
        {
          id: 'emission',
          name: this.$t('party_type_meth.emission')
        },
        {
          id: 'reception',
          name: this.$t('party_type_meth.reception')
        }
      ],
      isSuperAdmin: false
    }
  },

  computed: {
    ...mapGetters([
      'activeUser',
      'partiesService',
      'queryPartiesService',
      'isShowNameServiceParty',
      'isShowTaxServiceParty',
      'isShowEnabledServiceParty',
      'isShowCountryServiceParty',
      'isShowSellerServiceParty',
      'isShowBuyerServiceParty',
      'isShowThirdServiceParty',
      'isShowSponsorServiceParty',
      'isShowProvinceServiceParty',
      'isShowCreationDateTimeServiceParty',
      'isShowRegisterServiceParty',
      // Permisos
      'canAdminIndra',
      'canModifyProject',
      'primaryColor',
      'getActiveLang',
      'optionsFilterCommunicationsMethods'
    ])
  },

  components: {
    B2bFiltersPartiesService,
    B2bTableMenuServiciosEmpresas,
    B2bTableSelectRows
  },

  methods: {
    ...mapActions([
      'getPartiesService',
      'getServiceDetail',
      'queryPartiesServiceState',
      'updateStatusPartiesService',
      'updatePartiesService',
      'selectPartiesService',
      'downloadPartiesByServiceCsv',
      'isPartySponsor',
      'canChangeMasterData',
      'canChangeRole',
      'getOptionsFilterCommunicationsMethodsParty',
      'insertCommunicationsMethodsParty'
    ]),

    /* Ordenar Tabla */
    async orderOnServer ({ column, order, prop }) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.order_table')
      })
      try {
        let stringSort = ''

        const dataQuery = {
          query: {},
          serviceId: this.$route.params.projectId
        }
        if (order === 'descending') {
          order = 'DESC'
        } else if (order === 'ascending') {
          order = 'ASC'
        } else {
          order = 'ASC'
        }
        if (this.withProject) {
          if (!prop) {
            prop = 'party.tradeName'
          } else {
            switch (prop) {
              case 'partyName':
                prop = 'party.tradeName'
                break
              case 'partyTaxIdNumber':
                prop = 'party.taxIdentificationNumber'
                break
              case 'gln':
                prop = 'party.gln'
                break
              case 'tradeName':
                prop = 'party.tradeName'
                break
              case 'taxIdentificationNumber':
                prop = 'party.taxIdentificationNumber'
                break
              case 'province':
                prop = 'party.province'
                break
              case 'country':
                prop = 'party.country.countryName'
                break
              case 'registerOrCompaniesLocation':
                prop = 'party.registerOrCompaniesLocation'
                break
            }
          }
        } else {
          if (!prop) {
            prop = 'tradeName'
          } else {
            switch (prop) {
              case 'partyName':
                prop = 'tradeName'
                break
              case 'partyTaxIdNumber':
                prop = 'taxIdentificationNumber'
                break
            }
          }
        }
        stringSort = prop + ',' + order
        this.queryPartiesService.sort = stringSort
        this.queryPartiesService.projectId = this.$route.params.projectId
        await this.queryPartiesServiceState(this.queryPartiesService)
        dataQuery.query = this.queryPartiesService
        const response = await this.getPartiesService(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('orderOnServer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Recoger Id de la Celda al hacer un click de raton */
    async updateSeller (row) {
      if (this.multipleSelection.length !== 0) {
        try {
          this.$confirm(this.$t('parties.notify.modify_all'), {
            confirmButtonText: this.$t('buttons.btnOk'),
            showCancelButton: false,
            center: true,
            iconClass: 'ods-icon-warning'
          }).then(async () => {
            const load = this.$loading({
              lock: true,
              text: this.$t('msg_generics.size_table')
            })
            await this.goUpdatePartiesSellerService(row)
            await this.refreshTable()
            load.close()
            this.$notify({
              title: this.$t('parties.notify.parties_updated'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          }).catch(() => {})
        } catch (error) {
          console.log('handleDeleteCentre CATCH:: ' + error)
          this.getNotificationErrorMessage(error)
        }
      } else {
        if (!row.seller && !row.buyer && !row.third) {
          const error = { data: { message: this.$t('auditory_detail.events.property.missing.required.projectparty.role_required') } }
          row.seller = true
          this.showNotificationError(error)
        } else {
          await this.goUpdatePartiesSellerService(row)
        }
      }
    },

    updateBuyer (row) {
      if (this.multipleSelection.length !== 0) {
        try {
          this.$confirm(this.$t('parties.notify.modify_all'), {
            confirmButtonText: this.$t('buttons.btnOk'),
            showCancelButton: false,
            center: true,
            iconClass: 'ods-icon-warning'
          }).then(async () => {
            const load = this.$loading({
              lock: true,
              text: this.$t('msg_generics.size_table')
            })
            await this.goUpdatePartiesBuyerService(row)
            await this.refreshTable()
            load.close()
            this.$notify({
              title: this.$t('parties.notify.parties_updated'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          }).catch(() => {})
        } catch (error) {
          console.log('handleDeleteCentre CATCH:: ' + error)
          this.getNotificationErrorMessage(error)
        }
      } else {
        if (!row.seller && !row.buyer && !row.third) {
          const error = { data: { message: this.$t('auditory_detail.events.property.missing.required.projectparty.role_required') } }
          row.buyer = true
          this.showNotificationError(error)
        } else {
          this.goUpdatePartiesBuyerService(row)
        }
      }
    },

    updateThird (row) {
      if (this.multipleSelection.length !== 0) {
        try {
          this.$confirm(this.$t('parties.notify.modify_all'), {
            confirmButtonText: this.$t('buttons.btnOk'),
            showCancelButton: false,
            center: true,
            iconClass: 'ods-icon-warning'
          }).then(async () => {
            const load = this.$loading({
              lock: true,
              text: this.$t('msg_generics.size_table')
            })
            await this.goUpdatePartiesThirdService(row)
            await this.refreshTable()
            load.close()
            this.$notify({
              title: this.$t('parties.notify.parties_updated'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          }).catch(() => {})
        } catch (error) {
          console.log('updateThird CATCH:: ' + error)
          this.getNotificationErrorMessage(error)
        }
      } else {
        if (!row.seller && !row.buyer && !row.third) {
          const error = { data: { message: this.$t('auditory_detail.events.property.missing.required.projectparty.role_required') } }
          row.third = true
          this.showNotificationError(error)
        } else {
          this.goUpdatePartiesThirdService(row)
        }
      }
    },

    updateSponsor (row) {
      if (this.multipleSelection.length !== 0) {
        try {
          this.$confirm(this.$t('parties.notify.modify_all'), {
            confirmButtonText: this.$t('buttons.btnOk'),
            showCancelButton: false,
            center: true,
            iconClass: 'ods-icon-warning'
          }).then(async () => {
            const load = this.$loading({
              lock: true,
              text: this.$t('msg_generics.size_table')
            })
            await this.goUpdatePartiesSponsorService(row)
            await this.refreshTable()
            load.close()
            this.$notify({
              title: this.$t('parties.notify.parties_updated'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          }).catch(() => {})
        } catch (error) {
          console.log('handleDeleteCentre CATCH:: ' + error)
          this.getNotificationErrorMessage(error)
        }
      } else {
        this.goUpdatePartiesSponsorService(row)
      }
    },

    async openDialogDeliveryMehods () {
      let openDelivery = true
      for (let i = 0; i < this.multipleSelectionBuyerSponsorIds.length; i++) {
        if (this.multipleSelectionBuyerSponsorIds[0].sponsor !== this.multipleSelectionBuyerSponsorIds[i].sponsor ||
          this.multipleSelectionBuyerSponsorIds[i].buyer === false) {
          openDelivery = false
        }
      }
      if (openDelivery === false) {
        await this.$notify({
          title: this.$t('parties.notify.not_buyer_sponsor'),
          type: 'error',
          position: 'top-right',
          customClass: 'b2b-notification-error',
          duration: 10000
        })
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('party_detail.load.add_delivery_method')
      })
      await this.getCommunicationsMethodsProject()
      load.close()
      this.isShowDialogDeliveryMehods = openDelivery
    },
    async getCommunicationsMethodsProject () {
      this.showCommunicationFilter = false
      if (!this.multipleSelectionBuyerIds[0].sponsor) {
        await this.getOptionsFilterCommunicationsMethodsParty({
          serviceId: this.$route.params.projectId,
          sender: 'SENDER'
        })
      } else if (this.multipleSelectionBuyerIds[0].sponsor) {
        this.showCommunicationFilter = true
        await this.getOptionsFilterCommunicationsMethodsParty({
          serviceId: this.$route.params.projectId,
          sender: 'SENDER'
        })
      }
    },
    onChangeCommunicationsMethods (data) {
      this.dialogCommunicationsMethodsForm.user = ''
      this.dialogCommunicationsMethodsForm.password = ''
      this.getCommunicationsMethod(data, true)
    },
    async getCommunicationsMethod (data, isChanged) {
      const comm = this.optionsFilterCommunicationsMethods.find(function (c) {
        return c.id === data
      })
      this.hasCredentials = false
      if (comm.credentials) {
        this.hasCredentials = true
      }
    },
    onChangeCommunicationsSender (data) {
      this.hasCredentials = false
      this.dialogCommunicationsMethodsForm.optionsFilterCommunicationsMethods = []
      this.dialogCommunicationsMethodsForm.communicationsmethodsId = null
      this.getCommunicationsMethodSender(data, true)
    },
    async getCommunicationsMethodSender (data, isChanged) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        const opt = this.optionsCommunicationsMethodsSender.find(function (c) {
          return c.id === data
        })
        if (opt.id === 'emission') {
          await this.getOptionsFilterCommunicationsMethodsParty({
            serviceId: this.$route.params.projectId,
            sender: 'SENDER'
          })
        } else {
          await this.getOptionsFilterCommunicationsMethodsParty({
            serviceId: this.$route.params.projectId,
            sender: 'RECEIVER'
          })
        }
      } finally {
        load.close()
      }
    },
    addCommunicationsMethodsParty (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('party_detail.load.add_delivery_method')
          })
          try {
            console.log(
              'addCommunicationsMethodsParty VALID: ',
              this.dialogCommunicationsMethodsForm
            )
            let copyIds = []
            copyIds = this.multipleSelectionIds
            const params = {
              serviceId: this.$route.params.projectId,
              partyId: copyIds,
              communicationsmethodsId: this.dialogCommunicationsMethodsForm
                .communicationsmethodsId,
              user: this.dialogCommunicationsMethodsForm.user,
              password: this.dialogCommunicationsMethodsForm.password,
              allProjects: this.dialogCommunicationsMethodsForm.checkAddAll
            }
            await this.insertCommunicationsMethodsParty(params)
            this.$notify({
              title: this.$t('party_detail.notify.add_delivery_method'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogDeliveryMehods = false
            this.dialogCommunicationsMethodsForm.checkAddAll = false
          }
        } else {
          console.log(
            'addCommunicationsMethodsParty INVALID: ',
            this.dialogCommunicationsMethodsForm
          )
        }
      })
    },
    async handleCloseDialogCommunicationsMethods () {
      this.$refs.formDialogCommunicationsMethods.resetFields()
      this.hasCredentials = false
      this.dialogCommunicationsMethodsForm.communicationsmethodsSenderId = 'emission'
      // await this.getCommunicationsMethodsProject()
    },

    /* Recoger Id de la Fila en la que esta el ratón */
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },

    /* Manejo de la selección múltiple */
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
      if (val.length === 0) {
        this.multipleSelection = []
      }
      this.multipleSelectionIds = this.multipleSelection.map(item => item.partyId)
      this.multipleSelectionBuyerSponsorIds = this.multipleSelection.map(item => ({ id: item.partyId, buyer: item.buyer, sponsor: item.sponsor }))
      this.multipleSelectionBuyerIds = this.multipleSelectionBuyerSponsorIds.filter(item => item.buyer === true)
    },

    /* Ir al detalle */
    async handleGoDetail (row) {
      if (this.withProject) {
        this.selectPartiesService(row)
        const response = await this.getServiceDetail(row.projectId)
        sessionStorage.setItem('partyName', this.currentRow.partyName)
        sessionStorage.setItem('projectName', response.name)
        router.push({
          name: 'party-page',
          params: {
            partyId: row.partyId,
            projectId: row.projectId,
            projectName: response.name,
            partyName: this.currentRow.partyName
          // projectParty: projectParty
          }
        })
      } else {
        sessionStorage.setItem('projectName', null)
        sessionStorage.setItem('partyName', this.currentRow.partyName)
        console.log('llamo a onlyparty-page')
        router.push({
          name: 'onlyparty-page',
          params: {
            partyId: row.partyId,
            projectId: null,
            projectName: null,
            partyName: this.currentRow.partyName
          // projectParty: projectParty
          }
        })
      }
    },

    /** Actualiza las empresas de un  proyecto se utiliza para actualizar el seller/buyer/sponsor */
    async goUpdatePartiesService (row) {
      console.log('goUpdatePartiesService...')
      try {
        let copyIds = []
        if (this.multipleSelection.length !== 0) {
          copyIds = this.multipleSelectionIds
        } else {
          copyIds[0] = row.partyId
        }
        const request = {
          projectId: this.$route.params.projectId,
          partyId: copyIds,
          sponsor: row.sponsor,
          buyer: row.buyer,
          seller: row.seller
        }
        const response = await this.updatePartiesService(request)
        if (this.multipleSelection.length !== 0) {
          await this.refreshTable()
        } else {
          row.sponsor = response.data[0].sponsor
        }
        console.log('sponsor: ', row.sponsor)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    async goUpdatePartiesSellerService (row) {
      console.log('goUpdatePartiesService...')
      try {
        let copyIds = []
        if (this.multipleSelection.length !== 0) {
          copyIds = this.multipleSelectionIds
        } else {
          copyIds[0] = row.partyId
        }
        const request = {
          projectId: this.$route.params.projectId,
          partyId: copyIds,
          seller: row.seller
        }
        const response = await this.updatePartiesService(request)
        if (this.multipleSelection.length !== 0) {
          await this.refreshTable()
        } else {
          row.sponsor = response.data[0].sponsor
        }
        console.log('sponsor: ', row.sponsor)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    async goUpdatePartiesBuyerService (row) {
      console.log('goUpdatePartiesService...')
      try {
        let copyIds = []
        if (this.multipleSelection.length !== 0) {
          copyIds = this.multipleSelectionIds
        } else {
          copyIds[0] = row.partyId
        }
        const request = {
          projectId: this.$route.params.projectId,
          partyId: copyIds,
          buyer: row.buyer
        }
        const response = await this.updatePartiesService(request)
        if (this.multipleSelection.length !== 0) {
          await this.refreshTable()
        } else {
          row.sponsor = response.data[0].sponsor
        }
        console.log('sponsor: ', row.sponsor)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    async goUpdatePartiesThirdService (row) {
      console.log('goUpdatePartiesService...')
      try {
        let copyIds = []
        if (this.multipleSelection.length !== 0) {
          copyIds = this.multipleSelectionIds
        } else {
          copyIds[0] = row.partyId
        }
        const request = {
          projectId: this.$route.params.projectId,
          partyId: copyIds,
          third: row.third
        }
        const response = await this.updatePartiesService(request)
        if (this.multipleSelection.length !== 0) {
          await this.refreshTable()
        } else {
          row.sponsor = response.data[0].sponsor
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    async goUpdatePartiesSponsorService (row) {
      console.log('goUpdatePartiesService...')
      try {
        let copyIds = []
        if (this.multipleSelection.length !== 0) {
          copyIds = this.multipleSelectionIds
        } else {
          copyIds[0] = row.partyId
        }
        const request = {
          projectId: this.$route.params.projectId,
          partyId: copyIds,
          sponsor: row.sponsor
        }
        const response = await this.updatePartiesService(request)
        if (this.multipleSelection.length !== 0) {
          await this.refreshTable()
        } else {
          row.sponsor = response.data[0].sponsor
        }
        console.log('sponsor: ', row.sponsor)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    /** Guarda el cambio de estado de una empresa(Habilita/Deshabilitada) */
    async updateStatusParty (row) {
      console.log('updateStatusParty...')
      let copyIds = []
      if (this.multipleSelection.length !== 0) {
        copyIds = this.multipleSelectionIds
      } else {
        copyIds[0] = row.partyId
      }
      const request = {
        projectId: this.$route.params.projectId,
        partyId: copyIds,
        enable: row.enable
      }
      if (this.multipleSelection.length !== 0) {
        try {
          this.$confirm(this.$t('parties.notify.modify_all'), {
            confirmButtonText: this.$t('buttons.btnOk'),
            showCancelButton: false,
            center: true,
            iconClass: 'ods-icon-warning'
          }).then(async () => {
            const load = this.$loading({
              lock: true,
              text: this.$t('msg_generics.size_table')
            })
            await this.updateStatusPartiesService(request)
            await this.refreshTable()
            load.close()
            this.$notify({
              title: this.$t('parties.notify.parties_updated'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          }).catch(() => {})
        } catch (error) {
          console.log('handleDeleteCentre CATCH:: ' + error)
          this.getNotificationErrorMessage(error)
        }
      } else {
        await this.updateStatusPartiesService(request)
      }
    },

    /* Formatear columna: Fecha */
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },

    formatterCountry (row, column) {
      return row.country != null ? this.$t('countries.country_' + row.country) : null
    },

    /* Renderizar Componente Menu Columnas */
    renderHeaderActions: h => {
      return <B2bTableMenuServiciosEmpresas />
    },

    /* Tamaño de la Tabla */
    async handleSizeChange (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.size_table')
      })
      try {
        const dataQuery = {
          query: {},
          serviceId: this.$route.params.projectId
        }
        this.queryPartiesService.projectId = this.$route.params.projectId
        this.queryPartiesService.size = val
        await this.queryPartiesServiceState(this.queryPartiesService)
        dataQuery.query = this.queryPartiesService
        const response = await this.getPartiesService(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleSizeChange CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Paginación */
    async handleCurrentChangePagination (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.pagination_table')
      })
      try {
        const dataQuery = {
          query: {},
          serviceId: this.$route.params.projectId
        }

        this.queryPartiesService.projectId = this.$route.params.projectId
        this.queryPartiesService.page = val - 1
        await this.queryPartiesServiceState(this.queryPartiesService)
        dataQuery.query = this.queryPartiesService
        const response = await this.getPartiesService(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleCurrentChangePagination CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async downloadPartiesServiceCsv () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_csv')
      })
      const params = {
        projectId: this.$route.params.projectId,
        partyName: this.queryPartiesService.partyName,
        partyTaxIdNumber: this.queryPartiesService.partyTaxIdNumber,
        creationDateTimeFrom: this.queryPartiesService.creationDateTimeFrom,
        creationDateTimeTo: this.queryPartiesService.creationDateTimeTo,
        buyer: this.queryPartiesService.buyer,
        sponsor: this.queryPartiesService.sponsor,
        seller: this.queryPartiesService.seller,
        active: this.queryPartiesService.active,
        sort: 'id,ASC',
        country: this.queryPartiesService.country
      }
      try {
        params.activeLang = this.getActiveLang
        const filename = await this.downloadPartiesByServiceCsv(params)
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('downloadPartiesServiceCsv CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async getModifyPermission () {
      if (this.$route.params.projectId) {
        const userCanChangeMasterData = await this.canChangeMasterData({ projectId: this.$route.params.projectId })
        const userCanChangeRole = await this.canChangeRole({ projectId: this.$route.params.projectId })

        this.canModifyMasterData = (userCanChangeMasterData)
        this.canModifyRole = (userCanChangeRole)
        this.canModifyParty = (this.canModifyMasterData && this.canModifyRole)
      }
    },

    async refreshTable () {
      const dataQuery = {
        query: {},
        serviceId: this.$route.params.projectId
      }
      this.queryPartiesService.projectId = this.$route.params.projectId
      dataQuery.query = this.queryPartiesService
      const response = await this.getPartiesService(dataQuery)
      this.totalResults = response.data.totalElements
      this.currentPage = response.data.number + 1
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
        case 409:
          if (error.data.message) {
            errorSms = error.data.message
          } else {
            errorSms = 'global_error'
          }
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 404:
          errorSms = 'global_error'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })

    try {
      const dataQuery = {
        query: {},
        serviceId: this.$route.params.projectId
      }
      this.options = filters.filters
      this.queryPartiesService.projectId = this.$route.params.projectId
      dataQuery.query = this.queryPartiesService
      const response = await this.getPartiesService(dataQuery)
      this.totalResults = response.data.totalElements
      this.currentPage = response.data.number + 1

      this.withProject = (this.$route.params.projectId !== undefined && this.$route.params.projectId !== null)

      this.isSuperAdmin = this.activeUser.data.isSuperAdmin
      if (this.withProject) {
        await this.getModifyPermission()
      }
    } catch (error) {
      this.getNotificationErrorMessage(error)
      console.log('getUsers CATCH: ', error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-table-servicios-empresas {
  ::v-deep .ods-table {
    th {
      padding: rem(0);
      padding-top: rem(4);

      .cell {
        font-weight: 500;
      }

      &:last-child {
        padding-top: rem(0);
        .cell {
          .ods-dropdown {
            line-height: 32px;
          }
        }
      }
      .cell:last-child {
        .ods-dropdown {
          line-height: 32px;
        }
      }
    }
    &__row {
      .ods-button {
        padding: rem(1) rem(15) rem(0) rem(15);
        margin-left: rem(0);
        margin-right: rem(0);
        i {
          margin-left: rem(0);
        }
      }
    }
  }

  ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .ods-pagination {
        justify-content: flex-end;
        width: auto;
        padding-top: rem(0);
        float: right;
        &__label {
          padding-top: rem(0);
          float: right
        }
      }
    }
  }
  .selected-text {
    font-weight: bold;
  }
  .noselected-text {
    //color: var(--color-bg-interactive)
    color:blueviolet
  }
}
</style>
